import { render, staticRenderFns } from "./card-table_new.vue?vue&type=template&id=79ddfec0&scoped=true&"
import script from "./card-table_new.vue?vue&type=script&lang=js&"
export * from "./card-table_new.vue?vue&type=script&lang=js&"
import style0 from "./card-table_new.vue?vue&type=style&index=0&id=79ddfec0&prod&lang=scss&scoped=true&"
import style1 from "./card-table_new.vue?vue&type=style&index=1&id=79ddfec0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ddfec0",
  null
  
)

export default component.exports